import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import ColorList from "../../../../lib/ColorList";
import { getReports } from "../../../../actions/appointment";

const AttendChart = ({ dates }) => {
    const [attend, setAttend] = useState({
        colors: [],
        departments: [],
        count: []
    })

    const getAttendReports = () => {
        getReports(`attend&from=${dates?.from}&to=${dates?.to}&dtype=${dates?.dateType}`)
            .then((res) => {
                if (res?.status) {
                    if (res?.data.length > 0) {
                        let colors = ColorList(res.data.length);
                        let keys = []
                        let values = []
                        res.data.forEach(item => {
                            keys.push(item.name);
                            values.push(item.departAttandC) 
                        })
                        setAttend({ colors: colors, departments: keys, count: values })
                    }
                }
            })
            .catch(error => {
                console.log("error.......:)", error);
            });
    }

    useEffect(() => {
        getAttendReports();
    }, [dates])


    const data = {
        labels: attend.departments.length > 0 ? attend.departments : ["Red", "Blue", "Yellow"],
        datasets: [
            {
                data: attend.count.length > 0 ? attend.count : [46, 50, 25],
                backgroundColor: attend.colors.length > 0 ? attend.colors : ["#FF6384", "#36A2EB", "#FFCE56"],
                hoverBackgroundColor: attend.colors.length > 0 ? attend.colors : ["#FF6384", "#36A2EB", "#FFCE56"],
            },
        ],
    };
    return <Pie data={data} />;
};
export default AttendChart;
